import cx from 'classnames';

import Typography from '~/components/Typography';
import type { NavGroup, Publication, WebThemeV2 } from '~/interfaces/publication';

import useNavMenuSizeCheck from '../hooks/useNavMenuSizeCheck';

import CategoriesPopover from './CategoriesPopover';
import LinkPopover from './LinkPopover';
import SingleLink from './SingleLink';

interface Props {
  publication: Publication;
  theme: WebThemeV2;
}

const Menu = ({ publication, theme }: Props) => {
  const { content_tags, web_template } = publication;
  const { menuRef, isMounted, shouldUseMobileMenu } = useNavMenuSizeCheck();

  return (
    <div
      ref={menuRef}
      className={cx(
        !isMounted && 'opacity-0', // We want it to be transparent on initial render so that if we swap to the mobile menu there is no flash
        shouldUseMobileMenu ? 'hidden' : 'block',
      )}
    >
      <div className="z-20 flex gap-1">
        {web_template?.nav_groups?.map((group: NavGroup) => {
          const isCategoryGroup = group.is_category_group;

          if (isCategoryGroup) {
            return (
              <CategoriesPopover key={group.id} subLinks={content_tags} webTemplate={web_template} theme={theme}>
                <Typography
                  as="span"
                  color={theme.navbar_text_color}
                  fontFamilyv2={theme.navbar_font_family}
                  className="text-xs sm:block"
                >
                  {group.title}
                </Typography>
              </CategoriesPopover>
            );
          }

          if (group.nav_links.length === 0) return null;

          if (group.nav_links.length === 1) {
            return <SingleLink key={group.id} link={group.nav_links[0]} theme={theme} />;
          }

          return (
            <LinkPopover key={group.id} subLinks={group.nav_links} theme={theme}>
              <Typography
                as="span"
                color={theme.navbar_text_color}
                fontFamilyv2={theme.navbar_font_family}
                className="text-xs sm:block"
              >
                {group.title}
              </Typography>
            </LinkPopover>
          );
        })}
      </div>
    </div>
  );
};

export default Menu;
